function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.12996 7.82509C7.90893 7.82509 9.35123 6.07337 9.35123 3.91257C9.35123 1.75173 8.87762 0 6.12996 0C3.3822 0 2.90869 1.75173 2.90869 3.91257C2.90874 6.07337 4.35098 7.82509 6.12996 7.82509Z",
  fill: "inherit"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2067 13.6411C12.1471 9.87683 11.6555 8.80423 7.89349 8.12524C7.89349 8.12524 7.36383 8.80001 6.12954 8.80001C4.89525 8.80001 4.36569 8.12524 4.36569 8.12524C0.644737 8.79677 0.123132 9.8535 0.054574 13.5188C0.0489982 13.8181 0.0464283 13.8338 0.0454102 13.799C0.0456041 13.8641 0.0458951 13.9845 0.0458951 14.1945C0.0458951 14.1945 0.941564 16 6.12959 16C11.3176 16 12.2134 14.1945 12.2134 14.1945C12.2134 14.0596 12.2135 13.9657 12.2136 13.902C12.2126 13.9235 12.2105 13.8818 12.2067 13.6411Z",
  fill: "inherit"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5999 7.12689C12.0448 7.12689 13.2161 5.70419 13.2161 3.94921C13.2161 2.19419 12.8315 0.771484 10.5999 0.771484C10.2245 0.771484 9.90153 0.811872 9.62366 0.887267C10.1391 1.83748 10.2097 2.99163 10.2097 3.9129C10.2097 4.95601 9.92698 5.9519 9.40625 6.77649C9.76417 7 10.1697 7.12689 10.5999 7.12689Z",
  fill: "inherit"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.536 11.8497C15.4875 8.79248 15.0883 7.92135 12.0328 7.36987C12.0328 7.36987 11.6027 7.91795 10.6002 7.91795C10.5588 7.91795 10.5186 7.91669 10.479 7.9149C11.116 8.20207 11.6954 8.60193 12.1221 9.18705C12.8598 10.1986 13.0294 11.5575 13.0644 13.5537C15.1201 13.1475 15.5414 12.2993 15.5414 12.2993C15.5414 12.1887 15.5414 12.1129 15.5415 12.0611C15.5407 12.0793 15.539 12.0466 15.536 11.8497Z",
  fill: "inherit"
});

var SvgIconUsers = function SvgIconUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "white",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-users.42b68931.svg";
export { ForwardRef as ReactComponent };